import type { FC } from 'react';
import Container from '~/components/layout/Container';

interface HeroContentProps {
  slogan: string;
}

const HeroContent: FC<HeroContentProps> = ({ slogan }) => {
  return (
    <Container className="flex items-center h-[200px] md:h-full justify-center">
      <h1 className="text-[30px] font-raleway h-auto md:h-10 md:pl-48 text-center [text-shadow:0_0_28px_#dddddd] font-bold text-white md:text-[#16437c]">
        "{slogan}"
      </h1>
    </Container>
  );
};

export default HeroContent;